export default {
  "about.title": "关于我们",
  "about.brand.title": "品牌介绍",
  "about.brand.content": "爱液视频是一家专注于正版视频内容分发的官方平台，致力于为广大用户提供优质、高清、合法的视频观影体验。自成立以来，我们始终坚持正版授权原则，与国内外众多内容制作方和发行方建立了深度合作关系。\n\n我们的平台汇聚了电影、电视剧、综艺、动漫、纪录片等多元化的视频内容，覆盖用户多样化的观影需求。通过持续的技术创新，我们实现了多终端无缝切换、智能清晰度调节、个性化内容推荐等功能，为用户打造极致流畅的观影体验。\n\n爱液视频始终秉持\"内容为王、用户至上\"的理念，不断丰富内容库，优化产品体验，努力成为用户最信赖的正版视频平台。",
  "about.reputation.title": "品牌口碑",
  "about.reputation.subtitle": "来自用户的真实评价与认可",
  "about.reputation.count": "累计好评",
  "about.reputation.users": "活跃用户",
  "about.reputation.rating": "用户满意度",
  "about.reputation.awards": "行业奖项",
  "about.review1.name": "张先生",
  "about.review1.role": "年度会员",
  "about.review1.content": "用了爱液视频两年多了，内容丰富更新快，画质也很清晰，会员价格也很合理，非常推荐！",
  "about.review2.name": "李女士",
  "about.review2.role": "季度会员",
  "about.review2.content": "之前一直找不到正版高清的视频平台，朋友推荐了爱液视频后就一直用到现在，体验真的很棒。",
  "about.review3.name": "王同学",
  "about.review3.role": "月度会员",
  "about.review3.content": "学生党也能接受的会员价格，而且内容真的很全，追剧看综艺都很方便，离线下载功能太实用了。",
  "about.review4.name": "赵先生",
  "about.review4.role": "年度会员",
  "about.review4.content": "作为影视爱好者，爱液视频的正版授权让我看得放心，4K画质的观影体验也非常震撼。",
  "about.contact.title": "联系我们",
  "about.contact.subtitle": "如有任何问题或合作意向，欢迎随时与我们联系",
  "about.contact.address.label": "公司地址",
  "about.contact.address.value": "北京市朝阳区建国路88号SOHO现代城A座18层",
  "about.contact.phone.label": "客服热线",
  "about.contact.phone.value": "400-888-8888",
  "about.contact.email.label": "电子邮箱",
  "about.contact.email.value": "service@aiyivideo.com",
  "about.contact.hours.label": "工作时间",
  "about.contact.hours.value": "周一至周日 9:00 - 21:00",
  "about.contact.wechat.label": "官方微信",
  "about.contact.wechat.value": "aiyivideo_official",
  "about.contact.form.name": "姓名",
  "about.contact.form.email": "邮箱",
  "about.contact.form.phone": "电话",
  "about.contact.form.message": "留言内容",
  "about.contact.form.submit": "提交留言",
  "about.contact.form.success": "留言提交成功，我们会尽快与您联系！",
  "about.contact.form.error": "提交失败，请稍后重试。",
};